var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0A6ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2863 6.00575L8.44467 11.8853L5.59973 8.66103C5.3342 8.35757 4.84107 8.31964 4.53761 8.58517C4.23415 8.8507 4.19622 9.34382 4.46175 9.64728L7.83775 13.4785L7.87568 13.5164L7.91362 13.5543C7.95155 13.5543 7.95155 13.5923 7.98948 13.5923L8.02741 13.6302C8.06535 13.6302 8.10328 13.6681 8.14121 13.6681H8.17914C8.21708 13.6681 8.29294 13.6681 8.33087 13.6681C8.36881 13.6681 8.40674 13.6681 8.4826 13.6681H8.52054C8.55847 13.6681 8.5964 13.6681 8.63433 13.6302C8.63433 13.6302 8.67227 13.6302 8.67227 13.5923C8.7102 13.5923 8.7102 13.5543 8.74813 13.5543L8.78607 13.5164L8.824 13.4785L15.2725 7.02993C15.576 6.72647 15.576 6.27128 15.2725 5.96782C14.9691 5.66436 14.5898 5.70229 14.2863 6.00575Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.7c38466016ed65a8d02400c8f0c357c5.svg";
export { ForwardRef as ReactComponent };